"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
    onCreate: function () {
        this.state = { editFields: false };
        GState.bind(this, ['tenant']);
    },
    onAdd: function (type) {
        window.Extensions.run('Onboarding', {
            action: 'library',
            callback: function ({reference}) {
                this.onApply(type, reference);
            }.bind(this)
        });
    },
    onApply: function (type, reference) {
        if (!this.state.tenant.settings.onboarding)
            this.state.tenant.settings.onboarding = {};
        this.state.tenant.settings.onboarding[type] = {
            enabled: true,
            reference,
            requiredFields: []
        };
        GState.tenant.update({ onboarding: this.state.tenant.settings.onboarding }, 'settings');
        window.Extensions.quit('Onboarding');
    },
    onUpdate: function (type, key, value) {
        if (!this.state.tenant.settings.onboarding || !this.state.tenant.settings.onboarding[type])
            return;
        this.state.tenant.settings.onboarding[type][key] = value;
        GState.tenant.update({ onboarding: this.state.tenant.settings.onboarding }, 'settings');
    },
    onEdit: function (type, fields) {
        this.state.editFields = type !== false ? {
            type,
            fields
        } : false;
    },
    onDelete: function (type) {
        if (!this.state.tenant.settings.onboarding || !this.state.tenant.settings.onboarding[type])
            return;
        this.state.tenant.settings.onboarding[type] = null;
        GState.tenant.update({ onboarding: this.state.tenant.settings.onboarding }, 'settings');
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Settings/Admin/sections/Onboardings/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    Bx_template = require("../../../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    Row_template = require("../../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_assign = require("marko/dist/runtime/helpers/assign"),
    marko_dynamicTag = require("marko/dist/runtime/helpers/dynamic-tag"),
    AddFields_template = require("./components/AddFields.marko"),
    AddFields_tag = marko_loadTag(AddFields_template),
    WSAdapt_template = require("../../../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    marko_attrs0 = {
        "class": "py-1"
      },
    marko_attrs1 = {
        "class": "checkbox checkbox-secondary"
      },
    marko_attrs2 = {
        "class": "font-medium-3 px-50 text-primary"
      },
    marko_attrs3 = {
        "class": "list-inline m-0 d-inline-flex align-items-center"
      },
    marko_attrs4 = {
        "class": "px-75"
      },
    marko_attrs5 = {
        "class": "btn btn-secondary"
      },
    marko_attrs6 = {
        "class": "px-75"
      },
    marko_attrs7 = {
        "class": "btn btn-secondary"
      },
    marko_attrs8 = {
        "class": "list-inline px-2"
      },
    marko_attrs9 = {
        "class": "px-1 py-25 m-25 round theme-bg-lighten"
      },
    marko_attrs10 = {
        "class": "font-medium-3"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("dd0e4d"),
    marko_node0 = marko_createElement("br", null, "25", null, 0, 0, {
        i: marko_const_nextId()
      });

const AccountTypes = [
  { type: 'admin', disabled: true }, 
  { type: 'instructor', disabled: true }, 
  { type: 'learner' }
];

function render(input, out, __component, component, state) {
  var data = input;

  function macro_Section(out, { type, disabled, enabled, reference, requiredFields }) {
    out.be("section", marko_attrs0, "0", component);

    Row_tag({
        class: "d-flex align-items-center",
        col: [
            {
                renderBody: function(out) {
                  out.be("div", marko_attrs1, "3", component);

                  out.e("input", {
                      type: "checkbox",
                      id: ("enable-" + type) + "-onboarding",
                      disabled: disabled,
                      checked: ((!disabled) && reference) && enabled
                    }, "4", component, 0, 0, {
                      onchange: __component.d("change", e => reference && component.onUpdate( type, 'enabled', e.target.checked ), false)
                    });

                  out.be("label", {
                      "for": ("enable-" + type) + "-onboarding"
                    }, "5", component);

                  Locale_tag({
                      class: marko_classValue([
                        "font-medium-3",
                        disabled ? "text-muted" : false
                      ]),
                      text: ("Enable for " + type) + " account"
                    }, out, __component, "6");

                  if (reference) {
                    out.e("span", marko_attrs2, "7", component, 3)
                      .t("(")
                      .t(reference, component)
                      .t(")");
                  }

                  out.ee();

                  out.ee();
                }
              },
            {
                class: "col-5 text-right",
                renderBody: function(out) {
                  out.be("ul", marko_attrs3, "9", component);

                  if (reference) {
                    out.be("li", {
                        title: Locale("Edit"),
                        "class": "cursor-pointer"
                      }, "10", component, null, 0, {
                        onclick: __component.d("click", "onEdit", false, [
                            type,
                            requiredFields
                          ])
                      });

                    Bx_tag({
                        class: marko_classValue([
                          "font-large-1 px-75 py-50",
                          disabled ? "text-muted" : false
                        ]),
                        type: "pencil"
                      }, out, __component, "11");

                    out.ee();

                    out.be("li", {
                        title: Locale("Remove"),
                        "class": "cursor-pointer"
                      }, "12", component, null, 0, {
                        onclick: __component.d("click", "onDelete", false, [
                            type
                          ])
                      });

                    Bx_tag({
                        class: marko_classValue([
                          "font-large-1 px-75 py-50",
                          disabled ? "text-muted" : false
                        ]),
                        type: "trash"
                      }, out, __component, "13");

                    out.ee();

                    out.be("li", marko_attrs4, "14", component);

                    out.be("button", marko_attrs5, "15", component, null, 0, {
                        onclick: __component.d("click", "onAdd", false, [
                            type
                          ])
                      });

                    Locale_tag({
                        text: "Replace"
                      }, out, __component, "16");

                    out.ee();

                    out.ee();
                  } else if (!disabled) {
                    out.be("li", marko_attrs6, "17", component);

                    out.be("button", marko_attrs7, "18", component, null, 0, {
                        onclick: __component.d("click", "onAdd", false, [
                            type
                          ])
                      });

                    Locale_tag({
                        text: "Add"
                      }, out, __component, "19");

                    out.ee();

                    out.ee();
                  }

                  out.ee();
                }
              }
          ]
      }, out, __component, "1");

    if (Array.isArray(requiredFields) && requiredFields.length) {
      out.be("ul", marko_attrs8, "20", component);

      var $for$0 = 0;

      marko_forOf(requiredFields, function(field, index) {
        var $keyScope$0 = "[" + (($for$0++) + "]");

        out.e("li", marko_attrs9, "21" + $keyScope$0, component, 1)
          .t(field, component);
      });

      out.ee();
    }

    out.ee();
  }

  WSAdapt_tag({
      ns: "col-8",
      qs: "col-10",
      hs: "col-12",
      renderBody: function(out) {
        out.be("p", marko_attrs10, "23", component);

        Locale_tag({
            renderBody: function(out) {
              out.t("Create and manage onboarding steps to inform or get some required information from your first time users of any account type.");
            }
          }, out, __component, "24");

        out.ee();

        out.n(marko_node0, component);

        var $for$1 = 0;

        marko_forOf(AccountTypes, function(each, index) {
          var $keyScope$1 = "[" + (($for$1++) + "]");

          marko_dynamicTag(out, macro_Section, function() {
            return marko_assign({}, each, (state.tenant.settings.onboarding && state.tenant.settings.onboarding[each.type]) || {});
          }, null, null, null, __component, "27" + $keyScope$1);
        });

        if (state.editFields) {
          AddFields_tag({
              fields: state.editFields.fields
            }, out, __component, "26", [
            [
              "dismiss",
              "onEdit",
              false,
              [
                  false
                ]
            ],
            [
              "submit",
              "onUpdate",
              false,
              [
                  state.editFields.type,
                  "requiredFields"
                ]
            ]
          ]);
        }
      }
    }, out, __component, "22");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
